import { RateServiceRouteService } from 'common/data';
import { BaseService } from 'core/services';
import { findParams } from 'core/utils';
import _ from 'lodash';

class RateService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new RateServiceRouteService());
	}

	getAmazonShippingServices = shippingServiceParams => {
		const url = this.routeService.getAmazonShippingServices(shippingServiceParams);
		return this.apiClient.post(url, shippingServiceParams);
	};

	findCarrierServiceWithRates = filter => {
		const url = this.routeService.findCarrierServiceWithRates(filter);
		return this.apiClient.post(url, findParams(filter));
	};

	fetchRates = requestBody => {
		const url = this.routeService.fetchRates();
		return this.apiClient.post(url, requestBody);
	};

	getRates = rateParams => {
		const url = this.routeService.getRates(rateParams);
		return this.apiClient.post(url, findParams(rateParams));
	};
}

export default RateService;



// WEBPACK FOOTER //
// ./src/common/data/services/RateService.js